import { Button, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

export function NoDataBanner({
  text,
  "data-test": dataTest,
}: {
  text: string;
  "data-test"?: string;
}) {
  const { t } = useTranslation();

  const handleOnClick = () => {
    window.open(t("call_context.learn_more_url"), "_blank");
  };

  return (
    <Typography
      variant="bodyRegularS"
      color="text-disabled"
      data-test={dataTest}
    >
      {text}
      <Button
        mode="link"
        variant="secondary"
        size="xSmall"
        onClick={handleOnClick}
      >
        {t("call_context.learn_more_button")}
      </Button>
    </Typography>
  );
}
